import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Attach admin JWT if present (only for /admin routes)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('trucrunch_admin_token');
  if (token && config.url?.includes('/admin')) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const publicApi = {
  getProducts: () => api.get('/products').then((r) => r.data),
  createOrder: (payload) => api.post('/orders', payload).then((r) => r.data),
  submitEntry: (payload) => api.post('/contest/entries', payload).then((r) => r.data),
  getLeaderboard: () => api.get('/contest/leaderboard').then((r) => r.data),
  getTodayTop: () => api.get('/contest/today').then((r) => r.data),
  getMyScore: (email) => api.get('/contest/my-score', { params: { email } }).then((r) => r.data),
  submitPartner: (payload) => api.post('/partners', payload).then((r) => r.data),
  validateCoupon: (code, subtotal) => api.post('/coupons/validate', { code, subtotal }).then((r) => r.data),
  trackOrder: (id, email) => api.get(`/orders/${id}`, { params: { email } }).then((r) => r.data),
};

export const authApi = {
  exchangeSession: (sessionId) => api.post('/auth/session', null, { headers: { 'X-Session-ID': sessionId } }).then((r) => r.data),
  me: () => api.get('/auth/me').then((r) => r.data),
  logout: () => api.post('/auth/logout').then((r) => r.data),
  myOrders: () => api.get('/me/orders').then((r) => r.data),
  myOrder: (id) => api.get(`/me/orders/${id}`).then((r) => r.data),
};

export const adminApi = {
  login: (email, password) => api.post('/admin/login', { email, password }).then((r) => r.data),
  me: () => api.get('/admin/me').then((r) => r.data),
  stats: () => api.get('/admin/stats').then((r) => r.data),
  orders: () => api.get('/admin/orders').then((r) => r.data),
  updateOrder: (id, payload) => api.patch(`/admin/orders/${id}`, payload).then((r) => r.data),
  entries: () => api.get('/admin/contest-entries').then((r) => r.data),
  deleteEntry: (email) => api.delete(`/admin/contest-entries/${encodeURIComponent(email)}`).then((r) => r.data),
  partners: () => api.get('/admin/partners').then((r) => r.data),
  coupons: () => api.get('/admin/coupons').then((r) => r.data),
  couponInsights: () => api.get('/admin/coupons/insights').then((r) => r.data),
  createCoupon: (payload) => api.post('/admin/coupons', payload).then((r) => r.data),
  updateCoupon: (id, payload) => api.patch(`/admin/coupons/${id}`, payload).then((r) => r.data),
  deleteCoupon: (id) => api.delete(`/admin/coupons/${id}`).then((r) => r.data),
  salesReport: (bucket = 'day', days = 30) => api.get('/admin/reports/sales', { params: { bucket, days } }).then((r) => r.data),
  topReport: (days = 30) => api.get('/admin/reports/top', { params: { days } }).then((r) => r.data),
  analytics: () => api.get('/admin/analytics').then((r) => r.data),
  complaints: () => api.get('/admin/complaints').then((r) => r.data),
  updateComplaint: (id, status) => api.patch(`/admin/complaints/${id}`, { status }).then((r) => r.data),
  getAnnouncement: () => api.get('/settings/announcement').then((r) => r.data),
  setAnnouncement: (payload) => api.put('/admin/settings/announcement', payload).then((r) => r.data),
  exportCsv: async (kind) => {
    // kind: 'orders' | 'contest-entries' | 'partners' | 'coupons'
    const res = await api.get(`/admin/export/${kind}.csv`, { responseType: 'blob' });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = `trucrunch-${kind}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  },
};
